module.exports = __webpack_public_path__ + "static/media/avatar1.9a865693.png";